/**
 * This file defines all the backend service calls available to the system.
 */

import { fetchEnhanced } from "./connection-utils";

/**
 * Requests the creation of a new local account.
 */
export function createAccount(requestData, onSuccess, onFail) {
  const request = {
    method: 'POST',
    body: JSON.stringify(requestData)
  };

  fetchEnhanced('/v1/account/create', request, onSuccess, onFail);
}

/**
 * Requests the validation of a local account.
 */
export function validateAccount(requestData, onSuccess, onFail) {
  const request = {
    method: 'POST',
    body: JSON.stringify(requestData)
  };

  fetchEnhanced('/v1/account/validate', request, onSuccess, onFail);
}

/**
 * Requests a user identification token using local account credentials.
 */
export function loginUsingLocalAccount(requestData, onSuccess, onFail) {
  const request = {
    method: 'POST',
    body: JSON.stringify(requestData)
  };

  fetchEnhanced('/v1/authentication/authenticate', request, onSuccess, onFail);
}
